import { render, staticRenderFns } from "./TableViewData.vue?vue&type=template&id=a61855f0"
import script from "./TableViewData.vue?vue&type=script&lang=js"
export * from "./TableViewData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports